import {
  ApplicationTerm,
  IApplication,
  IApplicationData,
  PaymentTypeOption,
  ApplicationStatus,
} from '@/types/application'
import { ApiService } from './ApiService'
import { IPaginationParams, PaginatedQueryResponse } from '@/types/api'
import qs from 'qs'
import { ICourse } from '@/types/course'

interface IApplicationPayload {
  _id: string
  firstName: string
  lastName: string
  email: string
  courseId: string
  courseName: string
  courseImageUrl?: string
  course: ICourse
  currency: string
  price: number
  quantity: number
  courseDescription?: string
  paymentType: PaymentTypeOption
  statuses: ApplicationStatus[]
  userId: string
  applicationData?: IApplicationData
  status: ApplicationStatus
  applicationTerm?: ApplicationTerm
  cohortId: string
  flexibleRemuneration?: boolean
}

export type IApplicationPostPayload = Pick<
  IApplicationPayload,
  | 'courseId'
  | 'userId'
  | 'cohortId'
  | 'applicationData'
  | 'flexibleRemuneration'
>

export type IApplicationPatchPayload = Pick<
  IApplicationPayload,
  'applicationData' | 'applicationTerm'
>

export type IApplicationPostResponse = {
  applicationTerm: ApplicationTerm
  course: string
  statuses: ApplicationStatus[]
  user: string
  _id: string
}
export interface IApplicationGetFilters {
  courseId?: string
  userId?: string
  isRejected?: boolean
  include?: string[]
}

export type ICategoryGetParams = {
  filters?: IApplicationGetFilters
  pagination?: IPaginationParams
}

export class ApplicationService extends ApiService {
  static GET_PATH = `/applications`
  static POST_PATH = `/applications`
  static PATCH_PATH = `/applications`
  static GET_BY_ID_PATH = `/applications/:id`

  static async getById(applicationId: string) {
    return ApiService.get(
      ApplicationService.GET_BY_ID_PATH.replace(':id', applicationId)
    )
  }

  static async postApplication(body: IApplicationPostPayload) {
    return ApiService.post(ApplicationService.POST_PATH, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }

  static async getApplications(
    filters: IApplicationGetFilters = {},
    pagination: IPaginationParams = {}
  ): Promise<PaginatedQueryResponse<IApplication>> {
    const queryString = qs.stringify({ ...filters, ...pagination })

    return ApiService.get(`${ApplicationService.GET_PATH}?${queryString}`)
  }

  static async patchApplication(
    applicationId: string,
    body: Partial<IApplicationPayload>
  ) {
    return ApiService.patch(
      `${ApplicationService.PATCH_PATH}/${applicationId}`,
      body
    )
  }
}
